import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["body"];

  insertTag(event) {
    const tag = event.currentTarget.dataset.mergeTag;
    const fullTag = `{{${tag}}}`;
    let target = this.hasBodyTarget ? this.bodyTarget : null;
    if (!target) return;
    // rich_text_area wraps trix-editor in a div; resolve to the actual editor
    const trixEditor = target.querySelector?.("trix-editor") || (target.tagName === "TRIX-EDITOR" ? target : null);
    const textarea = target.tagName === "TEXTAREA" ? target : target.querySelector?.("textarea");

    if (trixEditor?.editor) {
      trixEditor.editor.insertString(fullTag);
      trixEditor.focus();
    } else if (textarea) {
      const start = target.selectionStart;
      const end = target.selectionEnd;
      const text = target.value;
      const before = text.substring(0, start);
      const after = text.substring(end);
      target.value = before + fullTag + after;
      target.selectionStart = target.selectionEnd = start + fullTag.length;
      target.focus();
    }
  }
}
